import basePath from "@/basePath"
export default [
  {
    component: 'CNavItem',
    name: 'Dashboard',
    to: basePath + 'dashboard',
    icon: 'cil-speedometer',
  },
  {
    component: 'CNavItem',
    name: 'Groups',
    to: basePath + 'groups/list',
    icon: 'cil-puzzle',
  },

  {
    component: 'CNavItem',
    name: 'Users',
    to: basePath + 'users',
    icon: 'cil-people',
  },

  {
    component: 'CNavItem',
    name: 'Reports',
    to: basePath + 'reports',
    icon: 'cil-chart-line',
  },

  {
    component: 'CNavItem',
    name: 'Invoices',
    to: basePath + 'invoices',
    icon: 'cil-paperclip',
  },
]
